import React, { useEffect } from 'react'

import WindowLocation from 'helpers/windowLocation'

import Api from 'services/api'

import { NoData, SinglePanePage } from 'styles/shared'
import { color } from 'styles/colors'

import Brand from 'helpers/brand'

import styled from 'styled-components'

const SIGNOUT_TIMEOUT = 30

const SignInError = () => {
  useEffect(() => {
    window.setTimeout(() => {
      WindowLocation.replace(Api.Session.logout)
    }, SIGNOUT_TIMEOUT * 1000)
  }, [])

  const onClickLoginLink = () => {
    WindowLocation.replace(Api.Session.logout)
  }

  return (
    <S.PaneContainer>
      <S.TopPane>
        <S.ProductLogo src={Brand.productLogoPath()} aria-label="product-logo" alt={`${Brand.productName()} logo`} />
      </S.TopPane>
      <SinglePanePage>
        <NoData>
          <h1>Failed to Login</h1>
          <h2>Please try again or call support at 844-359-0270 for assistance.<br />
            You will soon be redirected to the <S.LoginPageLink onClick={onClickLoginLink}>Login Page.</S.LoginPageLink>
          </h2>
        </NoData>
        <S.BrandLogo src={Brand.brandLogoPath()} aria-label="brand-logo" alt={`${Brand.brandLogoPath()} logo`} />
      </SinglePanePage>
    </S.PaneContainer>
  )
}

const S = {
  PaneContainer: styled.div`
    background-color: ${color('background')};
    height: 100%;
  `,
  TopPane: styled(SinglePanePage)`
    height: 150px;
  `,
  LoginPageLink: styled.a`
    color: ${color('anchor')};
    text-decoration: none;
    cursor: pointer;
  `,
  Header: styled.div`
    background-color: ${color('paneBackground')};
  `,
  ProductLogo: styled.img`
    height: 33px;
    float: right;
  `,
  BrandLogo: styled.img`
    height: 40px;
  `
}

export default SignInError
